import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchActivitiesAction } from 'modules/activities-management';

import ActivitiesManagement from './ActivitiesManagement';

const mapDispatchToProps = dispatch => ({
  fetchActivities: () => dispatch(fetchActivitiesAction()),
});
export default withRouter(connect(null, mapDispatchToProps)(ActivitiesManagement));



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/index.js